import React, { useCallback, useState } from 'react';

import {
    IntersectionObserverOptions,
    useIntersectionObserver,
} from 'hooks/useIntersectionObserver';

const intersectionObserverOptions: IntersectionObserverOptions = {
    threshold: 0.1,
    rootMargin: '-50px',
    triggerOnce: true,
};

interface LazyImageProps extends React.ImgHTMLAttributes<HTMLImageElement> {
    src: string;
    alt?: string;
    customOptions?: IntersectionObserverOptions;
}

export default function LazyImage({
    src,
    alt = '',
    customOptions,
    ...props
}: LazyImageProps) {
    const [visible, setVisible] = useState(false);
    const callback = useCallback(() => setVisible(true), [setVisible]);
    const options = { ...intersectionObserverOptions, ...customOptions };

    const ref = useIntersectionObserver(options, callback);
    return (
        <img ref={ref} src={visible ? src : undefined} {...props} alt={alt} />
    );
}
